(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	const removeElmIfEmpty = () => {
		$('.js-checkEmptyElm').each((idx, val) => {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	}
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	const removeBlockIfListEmpty = () => {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each((idx, val) => {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};
	// ニュース　ファイルサイズ変換
	const fileSize = () => {
		if($('.js-filesize').length) {
			const bytesToSize = (bytes) => {
				const sizes = ['Bytes', 'KB', 'MB', 'GB'];
				if (bytes === 0) return '0 Byte';
				let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
				let convSize = Math.floor(bytes / Math.pow(1024, i)* Math.pow(10, 1)) / Math.pow(10, 1);
				return convSize + sizes[i];
			};
			$('.js-filesize').each((idx,ele) => {
				$(ele).text(`（${bytesToSize($(ele).text())}）`);
			});
		}
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();
	fileSize();

})(window.jQuery, window.FUNCTIONS);
